/** 图片 / 文件 / 网页附件卡片共用尺寸与内边距（与 render.js 绘制一致） */
export const MEDIA_CARD_W = 280;
export const MEDIA_CARD_H = 200;
export const MEDIA_CARD_PAD = 4;
export const MEDIA_CARD_TITLE_H = 14;

export function mediaCardPreviewInsets() {
  return {
    paddingTop: MEDIA_CARD_PAD + MEDIA_CARD_TITLE_H,
    paddingX: MEDIA_CARD_PAD,
    paddingBottom: MEDIA_CARD_PAD,
  };
}

export function mediaCardInnerRect(el) {
  const pad = MEDIA_CARD_PAD;
  const titleH = MEDIA_CARD_TITLE_H;
  return {
    x: el.x + pad,
    y: el.y + pad + titleH,
    w: Math.max(0, el.width - pad * 2),
    h: Math.max(0, el.height - pad * 2 - titleH),
  };
}

export function isMediaCardType(cardType) {
  return cardType === 'image' || cardType === 'file' || cardType === 'webpage';
}

/** 走 DOM 浮层的预览卡（文件 / 网页）；图片卡仍在 Canvas 上 */
export function isDomPreviewCard(el) {
  return el?.type === 'card' && (el.cardType === 'file' || el.cardType === 'webpage');
}

export function isMediaCard(el) {
  if (el?.type !== 'card') return false;
  if (el.cardType === 'webpage') return !!(el.pageUrl || el.link);
  return isMediaCardType(el.cardType) && !!el.fileId;
}
